import Vue from 'vue'
import Vuex from 'vuex'
import api from 'api'
import user from './modules/user'
import admin from './modules/admin'
import statistics from './modules/statistics'
import router from 'router'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
	baseUrl: process.env.API_URL + "/api/audit",
	loginUrl: process.env.API_URL + "/api/login_check",
	refreshUrl: process.env.API_URL + "/api/token/refresh",
	token: localStorage.getItem('token'),
	refreshToken: localStorage.getItem('refreshToken'),
	headers: {
		'Authorization': 'Bearer ' + localStorage.getItem('token')
	},
	postHeaders: {
		'Content-Type': 'application/x-www-form-urlencoded',
		'Authorization': 'Bearer ' + localStorage.getItem('token')
	},
	badCredentials: false,
	accessDenied: false,
	alertData: {
		type: 'success',
		text: ''
	},
	showAlert: false,
	opignoMode: false,
	cursor: ''
};

const mutations = {
	TOKEN_UPDATED(state, data)	{
		state.badCredentials =  false
		state.accessDenied =  false
		state.token = data.newToken;
		localStorage.setItem('token', data.newToken);
		if (data.newRefreshToken)	{
			state.refreshToken = data.newRefreshToken;
			localStorage.setItem('refreshToken', data.newRefreshToken);
		}
		state.headers['Authorization'] = 'Bearer ' + data.newToken;
		state.postHeaders['Authorization'] = 'Bearer ' + data.newToken;
	},
	OPIGNO_MODE_UPDATED(state, newMode)	{
		state.opignoMode = newMode;
	},
	BAD_CREDENTIALS_UPDATED(state, value)	{
		state.badCredentials = value;
	},
	ACCESS_DENIED_UPDATED(state, value)	{
		state.accessDenied = value;
	},
	ALERT_DATA_UPDATED(state, value)	{
		if (router.history.current.name != 'Connection')	{
			state.alertData = value;
			state.showAlert = true;			
		}
	},
	SHOW_ALERT_UPDATED(state, value)	{
		state.showAlert = value;
	},
	CURSOR_UPDATED(state, value)	{
		state.cursor = value;
	}
};

const actions = {
	userLogin({state}, {username, password, callbacks})	{
		api.userLogin(state, username, password, callbacks);

	},
	userRefresh({state}, callbacks)	{
		api.userRefresh(state, callbacks);
	}
};

const store = new Vuex.Store({
	state,
	mutations,
	actions,
	modules: {
		user,
		admin,
		statistics
	},
	strict: debug
});

export default store